import { PopupContainer } from "../popup";
import authorizedSeal from "../../assets/home-page/authorized-interior-designer-seal.png";
import "./styles.scss";
import { Stack, Typography } from "@mui/material";

export const OurGuaranteePopup = ({
  visible,
  onClose,
}: {
  visible: boolean;
  onClose: () => void;
}) => {
  if (!visible) return null;
  return (
    <PopupContainer onClose={onClose} title="Our Guarantee">
      <div className="our-guarantee-content">
      <Typography variant="h4" color="white" className="font-size-4 text-center" padding={4}>
          Authorized, Trusted, Esteemed.
          </Typography> 
        <Stack className="image-row" direction="row" spacing={3}>
          <div className="image-container">
            <img
              src={authorizedSeal}
              alt="Authorized Interior Designer Seal"
              className="seal-image full-width-image"
            />
          </div>
          <div className="image-container">
            <img
              src={authorizedSeal}
              alt="Authorized Interior Designer Seal"
              className="seal-image full-width-image"
            />
          </div>
        </Stack>
                 
          <Typography variant="body1" color="white" className="font-size-4 text-center" padding={4}>
          We stand behind the professionals who bear our seal — so much so, that
          if a design project goes sour, we'll help you mediate a solution. Not
          only can you be confident in your choice, but also in having a partner
          with you every step of the journey.
        </Typography>
      </div>
    </PopupContainer>
  );
};
